import React from 'react';
import AccountPage from './AccountPage';

export default {
  title: 'Pages/Admin/AccountPage',
  component: AccountPage,
};

const Template = (args) => <AccountPage {...args} />;

export const View = Template.bind({});
View.args = {
  initialData: {
    firstName: 'CTD',
    lastName: 'Admin',
    email: 'admin@gmail.com',
  },
};
